import {
  navigateTo,
  getJsonAsync,
  postJsonAsync,
  putJsonAsync,
  deleteJsonAsync
} from 'shared/actions';

import {toastr} from 'react-redux-toastr';

import { displayErrorList } from '../../shared/error/errorManager';

import {
  change,
  initialize
} from 'redux-form'; 

import {
  retrieveEntries,
  handleContinueShoppingClick,
  hasPendingRosterChanges,
  retrieveAvailableBowlers,
  retrieveAvailableBowlersForVirtualEntries,
  retrieveUserVirtualEntries
} from '../shared/actions';
import {
  rostersHasUserIdModifications
  } from 'shared/actionRosterPosition';
import {
  setCartRostersComplete,
  convertEntriesFromCart,
  convertVirtualEntriesFromCart,
  displayEntryDetails,
  displayPurchasedEntryForm,
  displayVirtualEntryBowlerList,
  createCartRosterPositions, 
  cancelPurchasedEntryForm,
  cancelEntryPaymentLogHistory,
  cancelVirtualEventPaymentLogHistory,
  closeVirtualEntryEditing,
  cancelEntryDetails,
  reinsertManagedRosterIdsToCart,
  removeCartEntry,
  setCartVirtualEntryBowlerList,
  setCurrentCartRosterId,
  setCurrentCartRosterComplete,
  setEntryStateDisabled,
  setEntryDetailsInState,
  setRosterConfirmationVisibility,
  setCartRoster,
  setCartRosterIdForVirtualEventInCart,
  setCartBowlersForCartRosterId,
  setVirtualEntryRosterComplete,
  virtualEntrySubmittingStarts,
  virtualEntrySubmittingFinished,
  displayTeamOwnedVirtualEntries,
  assignTeamOwnedVirtualEntry,
  updateCartEntryForParentTeamOwnedVirtualEntry,
  updateCartEntryForChildTeamOwnedVirtualEntry,
  removeVirtualEntryBowlerFromCart,
  assignChildTeamOwnedVirtualEntry,
  resetTeamOwnedVirtualEntryEventAssignment,
  updateVirtualAvailableEntryFromCart,
  clearCartBowlers,
  clearPurchasedTeamOwnedVirtualEntries,
  storeTeamOwnedVirtualEntryMap,
  displayRosterPositions,
  setVirtualEntryBowlerList
} from '../shared/actionTypes';

import {
  cancelCartRosterEntryForm,
  setRostersComplete,
  setEventsForRosterCheckout
} from './actionTypes';

import {TEAM_ENTRY} from '../../shared/constants';

import {
  loadCheckout,
  updateSchedulerVirtualEventCount
} from '../checkout/actionTypes';

import {
  validateCart
} from '../checkout/actions';

import {
  getShoppingCart,
  setShoppingCart
} from '../actions';

export const retrieveEntriesFromCart = () => (dispatch, getState) => new Promise((resolve) => {
  const cart = getState().registration.payment.cart;
  const events = getState().registration.rostercheckout.events;
  const tournamentId = getState().registration.base.tournamentId;

  dispatch(convertEntriesFromCart(cart.squads, events));
 
  let tempCartEntries = JSON.parse(localStorage.tempCartEntries || null) || [];

  // If user returned to schedule calendar view and added more squads before checkout,
  // there might be managed rosters already in cart; if so, refresh those IDs from
  // local storage.
  if (tempCartEntries && tempCartEntries.length > 0 
      && tempCartEntries.some(entry => entry.cartRosterId.length == 36)) {
    dispatch(reinsertManagedRosterIdsToCart(tempCartEntries.slice()));
  }

  dispatch(retrieveEntries(tournamentId));
  dispatch(convertVirtualEntriesFromCart(cart.virtualEvents));
  let {cartEntries, cartVirtualEntries} = getState().registration.shared;

  dispatch(getRostersForExistingCartEntries(cartEntries, cartVirtualEntries)).then(() => {
    dispatch(checkForCompleteRosters());
  });
  resolve();
});

export const handleReviewCartClick = () => (dispatch, getState) => {
  const tournamentId = getState().registration.base.tournamentId;
  let cartVirtualEntries = getState().registration.shared.cartVirtualEntries;
  let tempCartEntries = JSON.parse(localStorage.tempCartEntries || null) || []; 
 
  if ((tempCartEntries && tempCartEntries.length > 0 && tempCartEntries.some(entry => entry.cartRosterId.length == 36))||(cartVirtualEntries.length > 0 && tempCartEntries.length == 0))
  {
    dispatch(navigateTo(`registration/checkout/${tournamentId}`));
  }
  else {
    dispatch(navigateTo(`registration/schedule/${tournamentId}`));
  }
};

export const handleCheckOutManageRosterClick = cartRosterId => (dispatch, getState) => {
  // prevent user from losing changes while editing an entry
  if (dispatch(hasPendingRosterChanges(handleCheckOutManageRosterClick.name, cartRosterId))) { return; }

  const {initialCountry, countries} = getState().registration.shared;

  let cartRosters = getState().registration.shared.cartEntries;
  const entry = cartRosters.find(entry => entry.cartRosterId == cartRosterId);

  const selectedCountry = countries.find(x => x.value === (entry.countryId || initialCountry)),
    disableEntryState = !selectedCountry || !selectedCountry.label || selectedCountry.label !== 'United States';

  // close other panels
  dispatch(cancelCartRosterEntryForm());
  dispatch(cancelEntryPaymentLogHistory());
  dispatch(cancelVirtualEventPaymentLogHistory());
  dispatch(closeVirtualEntryEditing());
  dispatch(clearPurchasedTeamOwnedVirtualEntries());

  dispatch(createCartRosterPositions(entry.eventNumberOfBowlers, entry.averageBased));

  // display form
  dispatch(displayPurchasedEntryForm(cartRosterId));
  
  dispatch(initialize('entryForm', {
    rosterPositionsQty: entry.eventNumberOfBowlers,
    id: entry.id,
    maxEntries: false
  }));

  if (entry.cartRosterId && entry.cartRosterId.length == 36) {
    dispatch(getJsonAsync(`registration/cartroster/${cartRosterId}`))
    .then(cartRoster => {
      dispatch(setCartRoster(cartRoster));

      if(cartRoster){
        const rosterData = JSON.parse(cartRoster.rosterData);

        const rosterPositions = rosterData.rosterPositions.map(roster => ({
          ...roster,
          ...{
            _searchValue: roster.bowler.usbcId || '',
            _processing: false,
            _retrieved: !!roster.bowler.usbcId && !roster.bowler.error,
            _errorMessage: roster.bowler.error ? roster.bowler.error.Message : null,
            averageRequired: entry.averageBased,
            bowler: roster.bowler.error ? {} : {
              ...roster.bowler,
              average: roster.bowler.average || ''
            }
          }
        }));
        
        dispatch(displayRosterPositions(rosterPositions));

        if(rosterData.parentTeamOwnedVirtualEntryAssignments) {
          const parentVirtualEntryAssignments = rosterData.parentTeamOwnedVirtualEntryAssignments;
          
          for(let i = 0; i < parentVirtualEntryAssignments.length; i++) {
            if(entry.parentVirtualEntryAssignments == null || entry.parentVirtualEntryAssignments.length == 0) {
              dispatch(updateCartEntryForParentTeamOwnedVirtualEntry(parentVirtualEntryAssignments[i].virtualEventName, null, true));
            }
            dispatch(assignTeamOwnedVirtualEntry(parentVirtualEntryAssignments[i].virtualEventName, entry.id, true));
          }
        }

        if(rosterData.childTeamOwnedVirtualEntryAssignments) {
          const childVirtualEntryAssignments = rosterData.childTeamOwnedVirtualEntryAssignments;
          
          for(let i = 0; i < childVirtualEntryAssignments.length; i++) {
            if(entry.childVirtualEntryAssignments == null || entry.childVirtualEntryAssignments.length == 0) {
              dispatch(updateCartEntryForChildTeamOwnedVirtualEntry(childVirtualEntryAssignments[i].virtualEventName, null, true, childVirtualEntryAssignments[i].rosterPosition));
            }
            dispatch(assignChildTeamOwnedVirtualEntry(childVirtualEntryAssignments[i].virtualEventName, entry.id, childVirtualEntryAssignments[i].rosterPosition, true));
          }
        }
        
        dispatch(initialize('entryForm', {
          rosterPositionsQty: entry.eventNumberOfBowlers,
          name: rosterData.name,
          countryId: !rosterData.countryId ? initialCountry : rosterData.countryId,
          state: rosterData.state,
          id: entry.id,
          maxEntries: false
        }));

        for(let i = 0; i < rosterData.rosterPositions.length; i++) {
          let rosterPosition = rosterData.rosterPositions[i]; 
          let average = rosterPosition.bowler.average;

          if (!rosterPosition.bowler.id) average = '';

          dispatch(change('entryForm', `average-${rosterPosition.position}`, average));
        } 
      }
    });
  }
  dispatch(setEntryStateDisabled(cartRosterId, disableEntryState));

  const tournamentId = getState().registration.base.tournamentId;

  // initialize available bowler list for doubles/singles dropwdown
  dispatch(retrieveAvailableBowlers(tournamentId, entry.eventId));
};

export const handleRemoveRosterItemClick = cartRosterId => (dispatch, getState) => new Promise((resolve) => {
  const {base, shared} = getState().registration;

  let entryInCart = shared.cartEntries.find(entry => entry.cartRosterId == cartRosterId);

  if (entryInCart && entryInCart.cartRosterId && entryInCart.cartRosterId.length == 36) {
    // call API to delete roster record from DB.
    dispatch(deleteJsonAsync(`registration/cartroster`, {
      id: cartRosterId,
      tournamentId: base.tournamentId,
      rosterType: "Entry"
    }))
    .then(() => {
      dispatch(checkForCompleteRosters());
      toastr.success('Complete!', 'Entry information successfully removed.');
      resolve();
    })
    .catch(() => {
      dispatch(setRosterConfirmationVisibility(false));
      resolve();
    });
  }

  dispatch(removeCartEntry(entryInCart.cartRosterId));
  let cartEntries = getState().registration.shared.cartEntries;

  if (cartEntries && cartEntries.length != 0) { 
    localStorage.tempCartEntries = JSON.stringify(cartEntries);
  }

  // find cart entry item by squad IDs and decrement count.
  const cart = getState().registration.payment.cart;
  let squadsInCart = cart.squads || [];
  let squadInCart = squadsInCart.find(item => item.eventID == entryInCart.eventID
    && item.id == entryInCart.squadId);

  if (squadInCart) {
    squadInCart.quantity--;
    if (squadInCart.quantity == 0) {
      const index = squadsInCart.indexOf(squadInCart);
    
      if (index !== -1) {
        squadsInCart.splice(index, 1);
      }
    }
  }

  dispatch(setShoppingCart(cart, base.tournamentId));
  dispatch(retrieveEntriesFromCart());
});

export const handleVirtualEntryManageRosterClick = (cartRosterId, virtualEventId, virtualEntryQuantity) => (dispatch, getState) => {
  // prevent user from losing changes while editing an entry
  if(dispatch(hasPendingRosterChanges(handleVirtualEntryManageRosterClick.name, cartRosterId))) { return; }

  const registration = getState().registration;
  const tournamentId = registration.base.tournamentId;
  let bowlers = [];
  const timeInMs = new Date().getTime();
  
  for (let i = 0; i < virtualEntryQuantity; i++)
  {
    bowlers.push({id: `${timeInMs}${i}`, bowlerId: ''});
  }

  // close other panels
  dispatch(cancelEntryDetails());
  dispatch(cancelPurchasedEntryForm());
  dispatch(cancelEntryPaymentLogHistory());
  dispatch(cancelVirtualEventPaymentLogHistory());

  dispatch(displayVirtualEntryBowlerList(cartRosterId));

  dispatch(retrieveAvailableBowlersForVirtualEntries(tournamentId, virtualEventId));

  if (cartRosterId.length === 36){
    dispatch(getJsonAsync(`registration/cartroster/${cartRosterId}`))
    .then(cartRoster => {
      const rosterData = JSON.parse(cartRoster.rosterData);

      for (let i = rosterData.virtualEntries.length; i < virtualEntryQuantity; i++)
      {
          rosterData.virtualEntries.push({id: `${timeInMs}${i}`, bowlerId: ''});
      }

      dispatch(setCartVirtualEntryBowlerList(rosterData.virtualEntries));
    });
  }
  else {
    dispatch(getJsonAsync(`virtualevent/${virtualEventId}/bowlers`))
      .then(virtualEventBowlers => {
        dispatch(setVirtualEntryBowlerList(virtualEventBowlers.map(x => ({
          ...x,
          bowlerId: x.bowlerId || ''
        }))));
    });

    // display new panel
    dispatch(setCartVirtualEntryBowlerList(bowlers.map(x => ({
      ...x,
      bowlerId: x.bowlerId || ''
    }))));
  }

  dispatch(updateVirtualAvailableEntryFromCart(cartRosterId, virtualEventId, virtualEntryQuantity));
};

export const handleRemoveVirtualEntryFromCart = (virtualEventId, bowlerId) => (dispatch, getState) => {
  dispatch(removeVirtualEntryBowlerFromCart(bowlerId));

  const tournamentId = getState().registration.base.tournamentId;
  let shoppingCart = getShoppingCart(),
    virtualEvent = shoppingCart.virtualEvents.find(x => x.id == virtualEventId);
    
  if(virtualEvent.quantity > 0)
    virtualEvent.quantity--;

  dispatch(updateSchedulerVirtualEventCount(virtualEvent, virtualEvent.quantity));
  dispatch(setShoppingCart(shoppingCart, tournamentId));
  dispatch(loadCheckout(shoppingCart));
  dispatch(validateCart());
};

export const handleVirtualEventSelectChecked = () => () => {
  // for later implementation
};

export const handleViewRosterClick = (entryId) => (dispatch) => {
  //  prevent user from losing changes while editing an entry
  if (dispatch(hasPendingRosterChanges(handleViewRosterClick.name, entryId))) { return; }

  dispatch(getJsonAsync(`registration/entry/${entryId}/readonly`))
  .then(entry => {
    // close other panels
    dispatch(cancelPurchasedEntryForm());
    dispatch(cancelEntryPaymentLogHistory());
    dispatch(cancelVirtualEventPaymentLogHistory());
    dispatch(closeVirtualEntryEditing());
    // display new panel
    dispatch(setEntryDetailsInState(entry));
    dispatch(displayEntryDetails(entryId));
  });
};

export const handleContinueShoppingSelection = () => (dispatch, getState) => {
  let cartEntries = getState().registration.shared.cartEntries;

  if (cartEntries && cartEntries.length != 0) { 
    localStorage.tempCartEntries = JSON.stringify(cartEntries);
  }

  dispatch(handleContinueShoppingClick());
};

export const handleSave = data => (dispatch, getState) => new Promise((resolve) => {
  const {base, shared} = getState().registration;
  const editingCartEntry = shared.cartEntries.find(cartEntry => cartEntry.editing);
  const cartRosterId = editingCartEntry.cartRosterId.length === 36 ? editingCartEntry.cartRosterId : null;
  const rosterData = { 
    name: data.name,
    squadId: editingCartEntry.squadId,
    state: data.state,
    countryId: data.countryId,
    rosterPositions: shared.rosterPositions,
    parentTeamOwnedVirtualEntryAssignments: editingCartEntry.parentVirtualEntryAssignments,
    childTeamOwnedVirtualEntryAssignments: editingCartEntry.childVirtualEntryAssignments
  };

  // Make sure we don't save if there are modifications in the user ID 
  let hasRosterPositionChanged = rostersHasUserIdModifications(shared.rosterPositions);

  if (hasRosterPositionChanged) {
    resolve();
    return;
  }

  dispatch(postJsonAsync(`registration/cartroster`, {
    id: cartRosterId,
    tournamentId: base.tournamentId,
    rosterType: "Entry",
    rosterData: JSON.stringify(rosterData)
  }, false))
  .then(response => {
    dispatch(setCurrentCartRosterId(editingCartEntry.cartRosterId, response.id));
    dispatch(addCartBowlersForVirtualEntries(shared.rosterPositions, editingCartEntry.cartRosterId, editingCartEntry.eventId));
    dispatch(setCurrentCartRosterComplete({ name: data.name, divisionName: response.divisionName }));
    dispatch(checkForCompleteRosters());
    dispatch(resetTeamOwnedVirtualEntryEventAssignment());
    toastr.success('Saved!', 'Entry information successfully saved.');

    let cartEntries = shared.cartEntries;

    if (cartEntries && cartEntries.length != 0) { 
      localStorage.tempCartEntries = JSON.stringify(cartEntries);
    }
  
    resolve();
  })
  .catch(error => {
    dispatch(setRosterConfirmationVisibility(false));
    
    if(!Array.isArray(error))
    {
      error = [ error.message ];
    }

    dispatch(displayErrorList(error));
    
    resolve();
  });
});

export const handleUpdateVirtualEntry = virtualEventId => (dispatch, getState) => {
  const {base, shared, payment} = getState().registration;
  const editingCartVirtualEntry = shared.cartVirtualEntries.find(cartEntry => cartEntry.editing);
  const cartRosterId = editingCartVirtualEntry.cartRosterId.length == 36 ? editingCartVirtualEntry.cartRosterId : null;
  const rosterData = { 
    virtualEventId: editingCartVirtualEntry.virtualEventId,
    virtualEntries: shared.cartVirtualBowlers
  };
  
  dispatch(virtualEntrySubmittingStarts(virtualEventId));
  dispatch(putJsonAsync('virtualevent/bowlers', {
    virtualEventId,
    virtualEntryBowlers: shared.virtualBowlers
  }))
  .then(() => {
    dispatch(virtualEntrySubmittingFinished(virtualEventId));
    dispatch(retrieveUserVirtualEntries(base.tournamentId)).then(() => dispatch(checkForCompleteRosters()));
  
    dispatch(virtualEntrySubmittingStarts(virtualEventId));
    dispatch(postJsonAsync(`registration/cartroster`, {
      id: cartRosterId,
      tournamentId: base.tournamentId,
      rosterType: "Virtual Entry",
      rosterData: JSON.stringify(rosterData)
    }, false))
    .then(response => {
      dispatch(setCurrentCartRosterId(editingCartVirtualEntry.cartRosterId, response.id));
      dispatch(setCartRosterIdForVirtualEventInCart(payment.cart.virtualEvents, virtualEventId, response.id));
      dispatch(virtualEntrySubmittingFinished(virtualEventId));
      dispatch(setVirtualEntryRosterComplete(response.id, { rosterData: JSON.stringify(rosterData) }));
      dispatch(checkForCompleteRosters());
      toastr.success('Saved!', 'Virtual entries successfully saved.');
      dispatch(setShoppingCart(payment.cart, base.tournamentId));

      dispatch(closeVirtualEntryEditing());
    })
    .catch((error) => {
      dispatch(virtualEntrySubmittingFinished(virtualEventId));      
      
      if(!Array.isArray(error))
      {
        error = [ error.message ];
      }
  
      dispatch(displayErrorList(error));
    });
  })
  .catch(() => dispatch(virtualEntrySubmittingFinished(virtualEventId)));
};

export const addCartBowlersForVirtualEntries = (rosterPositions, cartRosterId, eventId) => (dispatch) => {
  const bowlers = rosterPositions
    .filter(position => position.bowler.usbcId)
    .map(rp => 
      ({
        id: rp.bowler.id,
        name: `${rp.bowler.firstName} ${rp.bowler.lastName}`,
        memberId: rp.bowler.usbcId,
        assignedByOtherCaptain: rp.bowler.assignedByOtherCaptain,
        cartRosterId: cartRosterId,
        eventId: eventId
      })
    );

  dispatch(setCartBowlersForCartRosterId(bowlers, cartRosterId));
};

export const handleCountryChange = () => () => {
  // for later implementation
};

export const validate = (data) => {
  const errors = {};

  if (!data.name) {
    errors.name = 'We need to be able to identify your team.';
  }
  return errors;
};

export const handleAssignTeamOwnedVirtualEventClick = (virtualEventName, teamEntryId, value) => dispatch => {
  dispatch(updateCartEntryForParentTeamOwnedVirtualEntry(virtualEventName, teamEntryId, value));
  dispatch(assignTeamOwnedVirtualEntry(virtualEventName, teamEntryId, value));
};

export const handleAssignChildTeamOwnedVirtualEventClick = (virtualEventName, parentTeamEntryId, rosterPosition, value) => dispatch => {
  dispatch(updateCartEntryForChildTeamOwnedVirtualEntry(virtualEventName, parentTeamEntryId, value, rosterPosition));
  dispatch(assignChildTeamOwnedVirtualEntry(virtualEventName, parentTeamEntryId, rosterPosition, value));
};

export const checkForCompleteRosters = () => (dispatch, getState) => {
  const shared = getState().registration.shared;
  const entriesComplete =  shared.cartEntries.every(x => x.rosterComplete);
  const virtualEntriesComplete = shared.cartVirtualEntries.every(x => x.rosterComplete);
  const teamOwnedVirtualEntriesComplete = shared.parentVirtualEntryEvents.every(x => x.remaining === 0) && shared.childVirtualEntryEvents.every(x => x.remaining === 0);

  dispatch(setRostersComplete(entriesComplete && virtualEntriesComplete && teamOwnedVirtualEntriesComplete));
};

export const getRostersForExistingCartEntries = (cartEntries, cartVirtualEntries) => (dispatch) => new Promise((resolve) => {
  const promises = [];

  dispatch(clearCartBowlers());

  const timeInMs = new Date().getTime();

  cartEntries.forEach(
    (entry, index) => {
      if (entry && entry.cartRosterId && entry.cartRosterId.length === 36) {
        promises.push(dispatch(getJsonAsync(`registration/cartroster/${entry.cartRosterId}`))
          .then(cartRoster => {
            let rosterPositions = [];

            if (cartRoster) {
              let rosterData = JSON.parse(cartRoster.rosterData);

              if(rosterData.parentTeamOwnedVirtualEntryAssignments) {
                const parentVirtualEntryAssignments = rosterData.parentTeamOwnedVirtualEntryAssignments;
                
                for(let i = 0; i < parentVirtualEntryAssignments.length; i++) {
                  dispatch(storeTeamOwnedVirtualEntryMap(parentVirtualEntryAssignments[i].virtualEventName, entry.id, true));
                }
              }
              rosterPositions = rosterData.rosterPositions;
            }else{
              entry.cartRosterId = `${timeInMs}${index}`;
            }
            dispatch(setCartRostersComplete(entry.cartRosterId, cartRoster));
            dispatch(addCartBowlersForVirtualEntries(rosterPositions, entry.cartRosterId, entry.eventId));
          }));
      }
    }
  ); 

  cartVirtualEntries.forEach(
    virtualEntry => {
      if (virtualEntry && virtualEntry.cartRosterId && virtualEntry.cartRosterId.length === 36) {
        promises.push(dispatch(getJsonAsync(`registration/cartroster/${virtualEntry.cartRosterId}`))
          .then(cartRoster => {
            dispatch(setVirtualEntryRosterComplete(virtualEntry.cartRosterId, cartRoster));
          }));
      }
    }
  );

  Promise.all(promises).then(() => resolve());
});

export const retrieveVirtualEntriesFromCart = () => (dispatch, getState) => new Promise((resolve) => {
  const state = getState().registration;
  const cartVirtualEvents = state.payment.cart.virtualEvents;
  const tournamentId = state.base.tournamentId;

  let tempCartEntries = JSON.parse(localStorage.tempCartEntries || null) || [];

  tempCartEntries.forEach(
    entry => {
      if (entry.cartRosterId && entry.cartRosterId.length == 36) {
        dispatch(getJsonAsync(`registration/cartroster/${entry.cartRosterId}`))
        .then(cartRoster => {
          if (cartRoster) {
            const rosterData = JSON.parse(cartRoster.rosterData);
    
            if (rosterData.parentTeamOwnedVirtualEntryAssignments) {
              const parent = rosterData.parentTeamOwnedVirtualEntryAssignments;
              
              for (let i = 0; i < parent.length; i++) {
                dispatch(assignTeamOwnedVirtualEntry(parent[i].virtualEventName, entry.id, true));
              }
            }

            if (rosterData.childTeamOwnedVirtualEntryAssignments) {
              const child = rosterData.childTeamOwnedVirtualEntryAssignments;
              
              for (let i = 0; i < child.length; i++) {        
                dispatch(assignChildTeamOwnedVirtualEntry(child[i].virtualEventName, entry.id, child[i].rosterPosition, true));
              }
            }
          }
        });
      }
    }
  );

  dispatch(getJsonAsync(`tournament/${tournamentId}/virtualEvents`))
  .then(virtualEvents => {
    const tempParentTeamOwnedVirtualEvents = cartVirtualEvents
      .filter(ve => {
        const virtEvent = virtualEvents.find(x => x.id === ve.id);

        return virtEvent.owner === TEAM_ENTRY && virtEvent.virtualEventMaps[0].eventParentEventId === null;
      });

    let parentTeamOwnedVirtualEvents = tempParentTeamOwnedVirtualEvents.length == 0 ? [] : tempParentTeamOwnedVirtualEvents.map(cartItem => 
      Array.apply(null, {length: cartItem.quantity - state.shared.parentTeamOwnedVirtualEntries.length})
        .map((item, index) => ({virtualEventName: cartItem.name, id: `${new Date().getTime()}-${index}`, childEvent: false, parentTeamEntryId: null, teamEntryId: null, rosterPosition: 0, virtualEventId: cartItem.id, eventId: cartItem.eventId, isPurchased: false}))
    ).reduce((a, b) => a.concat(b));

    const tempChildOwnedVirtualEvents = cartVirtualEvents
      .filter(ve => {
        const virtEvent = virtualEvents.find(x => x.id === ve.id);

        return virtEvent.owner === TEAM_ENTRY && virtEvent.virtualEventMaps[0].eventParentEventId !== null;
      });

    let data = parentTeamOwnedVirtualEvents;

    if(tempChildOwnedVirtualEvents.length > 0){
      let childTeamOwnedVirtualEvents = tempChildOwnedVirtualEvents.map(cartItem => 
        Array.apply(null, {length: cartItem.quantity - state.shared.childTeamOwnedVirtualEntries.length})
          .map((item, index) => ({virtualEventName: cartItem.name, id: `${new Date().getTime()}-${index}`, childEvent: true, parentTeamEntryId: null, teamEntryId: null, rosterPosition: 0, virtualEventId: cartItem.id, bowlerCount: cartItem.eventNumberOfBowlers, eventId: cartItem.eventId, isPurchased: false}))
      ).reduce((a, b) => a.concat(b));

      data = data.concat(childTeamOwnedVirtualEvents);
    }

    dispatch(displayTeamOwnedVirtualEntries(data, null,null));    
    
    const storedTeamOwnedVirtualEntryMap = getState().registration.shared.teamOwnedVirtualEntryMap;

    if(storedTeamOwnedVirtualEntryMap != null && storedTeamOwnedVirtualEntryMap.length > 0) {
      storedTeamOwnedVirtualEntryMap.forEach( e => {
        dispatch(assignTeamOwnedVirtualEntry(e.virtualEventName, e.teamEntryId, e.value));
      });
    }
    
    dispatch(checkForCompleteRosters());

    resolve();
  });
});

export const retrieveEvents = tournamentId => dispatch => new Promise((resolve) =>{
  dispatch(getJsonAsync(`tournament/${tournamentId}/events`))
  .then(data => {
    dispatch(setEventsForRosterCheckout(data));
    resolve();
  })
  .catch(() => {});
});


// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/actions.js